export const colors = {
  backgroundColor: '#E4E8F0',
  foregroundColor: '#EAEEF6'
};
